import React, { Component } from 'react';
import { browserHistory } from 'react-router'
import EllipsisText  from 'react-ellipsis-text';

import {} from './ResearchHome.css';

import Articles from '../data/publicationsjson';

class ResearchHome extends Component {
    constructor(props) {
        super(props);
        document.title = "g-C3N4 Research";
        this.state = {
            loaded: false,
            articles: this.setArticleCards(Articles.articlelist)
        };
        
        this.state = {
            loaded: true,
            articles: this.state.articles
        };
    }

    showItem(item, e){
        e.preventDefault();
        browserHistory.push({ //browserHistory.push should also work here
            pathname: 'research/article',
            state: {item: item}
          }); 
    }

    setArticleCards(itemlist) {
        return (
            itemlist.map(item =>
                <div className={"Research-main-card " + item.colour + "Border"} key={item.id} onClick={this.showItem.bind(this, item)}>
                    <div className={"Research-main-header " + item.colour + "Back"} >
                        <EllipsisText className="Research-main-card-title"  text={item.title} length={58} />
                    </div>
                    <div className="Research-main-card-detail">
                        <div className="Research-main-card-detail-journal">
                            <EllipsisText className="Research-main-card-detail-journal-text" text={item.journal} length={34} />
                        </div>
                        <div className="Research-main-card-detail-abstract">
                            <EllipsisText className="Research-main-card-detail-abstract-text" text={item.abstract} length={150} />
                        </div>
                    </div>
                </div>
                )
            )
    }

    render() {
        
        if (this.state.loaded) {
            return (
                <div className="container">
                    <p className="title">Research </p>
                    <p className="subtitle">Links to the many areas of research into Graphitic Carbon Nitride </p>
                    <p>These are the main articles that we've been looking at, but we add more all the time. It's a big world!</p>

                    {/* <div className="Research-filter-container">
                        <div className="Research-filter-section Blue"><input className="Research-checkbox" type="checkbox"/> Synthesis</div>
                        <div className="Research-filter-section Red"><input className="Research-checkbox" type="checkbox"/>Photocatalysts</div>
                        <div className="Research-filter-section Yellow"><input className="Research-checkbox" type="checkbox"/>Hydrogen Generation</div>
                        <div className="Research-filter-section Green"><input className="Research-checkbox" type="checkbox"/>onic Actuator</div>
                    </div> */}

                    {this.state.articles} 
                </div>
            );
        } else {
            return (
                <div>
                    Loading...
                </div>
            )
        }
    }
}

export default ResearchHome;


// WEBPACK FOOTER //
// ./src/Research/ResearchHome.js